import { skipToken } from "@reduxjs/toolkit/query";

import { useGetProjectQuery } from "fond/api";
import { usePermissionCheck } from "fond/hooks/usePermissionCheck";
import { isSolveActive as getIsSolveActive } from "fond/project/redux";
import { useAppSelector } from "fond/utils/hooks";
import { Actions } from "fond/utils/permissions";

/** Whether the user can change the current version's planner input data. */
export const useCanEditPlannerInputs = (readOnly: boolean): boolean => {
  const projectId = useAppSelector((state) => state.project.projectId);
  const { currentData: project } = useGetProjectQuery(projectId || skipToken);
  const isSolveActive = useAppSelector(getIsSolveActive);
  const canEditProject = usePermissionCheck(Actions.PLANNER_PROJECT_EDIT, project?.Permission.Level);

  return !readOnly && !isSolveActive && canEditProject;
};
